var styleDataHash = "3b678715";
const injectCss = (() => {
  var css = `.-xNGz{display:flex;margin:0}.ArCtP{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));font-size:inherit;font-weight:inherit;line-height:28px;margin:0;max-width:270px;overflow:hidden;padding:0 4px;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.ArCtP:hover{text-decoration:underline}.ArCtP:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.ArCtP._63qPm{line-height:32px}.eaIgp{background:transparent;border:0}.eaIgp:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:480px){.ArCtP{max-width:160px}}}@container (width < 480px){.ArCtP{max-width:160px}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var url_link_button_default = {
  "toolbarUrlContainer": "-xNGz",
  "toolbarUrl": "ArCtP",
  "isMobile": "_63qPm",
  "toolbarUrlAnchor": "eaIgp"
};
export {
  url_link_button_default as default,
  injectCss
};
//# sourceMappingURL=url-link-button-scss.js.map
